import styled, { css } from 'styled-components';

import { RouterComponent_LinkWithStore as Link } from 'ggApp/modules/router';

export const AddressItem = styled.div`
    position: relative;

    &:after {
        position: absolute;
        z-index: 500;
        content: ' ';
        background-color: rgba(255, 255, 255, 0.75);
        background-image: url(./images/loaderBig.svg);
        background-position: 50% 50%;
        background-repeat: no-repeat;
        width: 100%;
        height: 100%;
        top: 0;
        left: 0;
        opacity: 0;
        visibility: hidden;
        transition: all 0.3s ease;
    }

    &:last-child {
        margin-bottom: 0;
    }

    ${({ loading }) => loading && css`
        &:after,
        &:before {
            opacity: 1;
            visibility: visible;
        }
    `}

    ${({ dark }) => dark && css`
        margin-top: -1px;

        &:first-child {
            margin-top: 0;
        }

        &:after {
            background: rgba(0, 0, 0, 0.5);
        }

        &:before {
            border: 3px solid #f3f3f3; /* Light grey */
            border-top: 3px solid #159bff; /* Blue */
            border-radius: 50%;
            width: 30px;
            height: 30px;
            animation: spin 2s linear infinite;
            position: absolute;
            top: 50%;
            left: 50%;
            margin: -15px 0 0 -15px;
            z-index: 600;

            content: ' ';
            display: block;

            transition: all 0.2s ease;
            opacity: 0;
            visibility: hidden;
        }
    `}
`;

export const Title = styled.div`
    font-size: 16px;
    line-height: 1.35;
    font-weight: 300;
    position: relative;
    letter-spacing: 0.3px;
    margin-bottom: 10px;
`;

export const Wrap = styled.div`
    padding: 20px;
    border: 1px solid;
    border-color: ${({ theme }) => theme.colors.secondaryBackground};
    margin-bottom: 20px;
    display: flex;
    justify-content: space-between;
    cursor: pointer;
    position: relative;

    -webkit-touch-callout: none;
    -webkit-user-select: none;
    -khtml-user-select: none;
    -moz-user-select: none;
    -ms-user-select: none;
    user-select: none;

    transition: border 0.2s ease, background 0.2s ease;

    &:hover {
        background-color: rgba(157, 153, 162, 0.08);
    }

    ${({ active }) => active && css`
        background-color: transparent !important;
        border-color: ${({ theme }) => theme.colors.secondary};
    `}

    ${({ noSelect }) => noSelect && css`
        cursor: auto;
    `}
`;

export const Info = styled.div`
    display: flex;
    flex-direction: column;
    flex: 1;
    padding: 0 20px 0 40px;
    position: relative;
    transition: padding 0.2s ease;

    ${({ single }) => single && css`
        padding-left: 20px;
    `}

    ${({ noSelect }) => noSelect && css`
        padding-left: 20px;
    `}
`;

export const Dot = styled.div`
    position: absolute;
    top: 50%;
    margin-top: -10px;
    left: -5px;
    opacity: 1;
    transition: opacity 0.2s ease;

    &:after,
    &:before {
        content: ' ';
        display: block;
        position: absolute;
        transition: all 0.2s ease;
    }

    &:after {
        width: 20px;
        height: 20px;
        top: 0;
        left: 0;
        border: 1px solid #c6c5c5;
        border-radius: 50%;
    }

    &:before {
        width: 14px;
        height: 14px;
        top: 3px;
        left: 3px;
        background: transparent;
        border-radius: 50%;
    }

    ${({ active }) => active && css`
        &:before {
            background: ${({ theme }) => theme.colors.secondary};
        }
    `}

    ${({ single }) => single && css`
        opacity: 0;
    `}

    ${({ noSelect }) => noSelect && css`
        opacity: 0;
    `}
`;

export const Name = styled.div`
    font-size: 20px;
    line-height: 1.35;
    font-weight: 300;
    position: relative;
    letter-spacing: 0.3px;
    word-break: break-word;

    ${({ dark }) => dark && css`
        color: #fff;
    `}
`;

export const Description = styled.div`
    margin-top: 5px;
`;

export const DescriptionValue = styled.div`
    font-size: 16px;
    line-height: 1.35;
    font-weight: 300;
    position: relative;
    letter-spacing: 0.3px;

    &:last-child {
        margin-bottom: 0;
    }

    ${({ dark }) => dark && css`
        color: #fff;
    `}
`;

export const Edit = styled(Link)`
    margin-top: 5px;
    color: #3d02ff;
    font-size: 16px;
    line-height: 1.35;
    letter-spacing: 0.3px;
    align-self: flex-start;

    ${({ dark }) => dark && css`
        color: #159bff;
    `}
`;
